enum LOAD_STATUS {
  before = 'loadBefore',
  start = 'loadStart',
  end = 'loadEnd',
  after = 'loadAfter',
}

export default LOAD_STATUS;
